import { render } from "./Funfacts.vue?vue&type=template&id=04d36b80"
import script from "./Funfacts.vue?vue&type=script&lang=js"
export * from "./Funfacts.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__